<!-- =========================================================================================
  File Name: UserList.vue
  Description: User List page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div id="schedule-loading-waypoints" class="vx-card p-6 vs-con-loading__container">
		<div class="flex flex-wrap items-center justify-end">
			<!-- ITEMS PER PAGE -->
			<div class="flex-grow">
				<vs-dropdown vs-trigger-click class="cursor-pointer">
					<div
						class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
					>
						<span class="mr-2"
							>{{
								paginationPageSize === 0
									? 0
									: currentPage * paginationPageSize - (paginationPageSize - 1)
							}}
							-
							{{
								eventsData.length - currentPage * paginationPageSize > 0
									? currentPage * paginationPageSize
									: eventsData.length
							}}
							{{ $t("Of") }} {{ pagination.total_records }}</span
						>
						<feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
					</div>
					<vs-dropdown-menu style="z-index: 55000">
						<vs-dropdown-item @click="paginationSetPageSize(20)">
							<span>20</span>
						</vs-dropdown-item>
						<vs-dropdown-item @click="paginationSetPageSize(50)">
							<span>50</span>
						</vs-dropdown-item>
						<vs-dropdown-item @click="paginationSetPageSize(100)">
							<span>100</span>
						</vs-dropdown-item>
						<vs-dropdown-item @click="paginationSetPageSize(200)">
							<span>200</span>
						</vs-dropdown-item>
					</vs-dropdown-menu>
				</vs-dropdown>
			</div>
			<vs-button
				icon-pack="feather"
				icon="icon-calendar"
				:title="$t('Routing.Map.Schedule.ClickToSchedule')"
				:disabled="getCheckedEvents.length <= 0"
				@click="scheduleWhitWaypoint"
				>{{ $t("Routing.Buttons.Schedule") }}
			</vs-button>
		</div>
		<div class="border border-solid d-theme-border-grey-light p-6 mt-2 rounded-lg">
			<vs-row vs-w="12" class="mb-2">
				<vs-col
					vs-justify="center"
					vs-align="center"
					vs-sm="12"
					vs-xs="12"
					:vs-lg="searchField.some((item) => item.value === 'resource') ? '3' : '5'"
				>
					<h5>
						{{ this.$t("Filters")
						}}<cite class="text-sm">{{ " (" + this.$t("DesignConfig.MultipleChoice") + ")" }}</cite>
					</h5>
					<v-select
						v-model="searchField"
						v-validate="'required'"
						multiple
						:clearable="false"
						:options="searchOptions"
						:dir="$vs.rtl ? 'rtl' : 'ltr'"
					>
						<template v-slot:no-options="{search, searching}">
							<template v-if="searching">
								{{ $t("NoResultsFoundFor") + " " }}<em>{{ search }}</em>
							</template>
						</template>
						<template #option="{label, disabled}">
							<span :class="{'disabled-option': disabled}"> {{ label }} </span>
						</template>
					</v-select>
				</vs-col>
				<vs-col
					vs-justify="center"
					vs-align="center"
					:vs-lg="searchField.some((item) => item.value === 'resource') ? '2' : '3'"
					vs-sm="12"
					vs-xs="12"
				>
					<div class="ml-2 mr-2">
						<label class="vs-input--label">{{ $t("CompanyCreate.InitDate") }}</label>
						<datepicker
							:language="$vs.rtl ? langEn : langEs"
							name="date_init"
							v-model="init_date"
							v-validate="'required'"
						></datepicker>
						<span class="text-danger text-sm" v-show="errors.has('date_init')">{{
							errors.first("date_init")
						}}</span>
					</div>
				</vs-col>
				<vs-col
					vs-justify="center"
					vs-align="center"
					:vs-lg="searchField.some((item) => item.value === 'resource') ? '2' : '3'"
					vs-sm="12"
					vs-xs="12"
				>
					<div class="mr-2">
						<label class="vs-input--label">{{ $t("CompanyCreate.EndDate") }}</label>
						<datepicker
							:language="$vs.rtl ? langEn : langEs"
							v-model="end_date"
							:disabledDates="disabledDatesTo"
							v-validate="'required'"
							name="date_end"
						></datepicker>
						<span class="text-danger text-sm" v-show="errors.has('date_end')">{{
							errors.first("date_end")
						}}</span>
					</div>
				</vs-col>
				<vs-col
					v-if="searchField.some((item) => item.value === 'resource')"
					vs-justify="center"
					vs-align="center"
					vs-lg="4"
					vs-sm="12"
					vs-xs="12"
				>
					<div class="mr-2">
						<label class="vs-input--label">{{ $t("Resource") }}</label>
						<v-select
							name="resource"
							class="select-large"
							v-model="selectedResource"
							:clearable="false"
							:options="resourceOptions"
							:dir="$vs.rtl ? 'rtl' : 'ltr'"
							:disabled="resourceOptions.length === 0"
						>
							<template v-slot:no-options="{search, searching}">
								<template v-if="searching">
									{{ $t("NoResultsFoundFor") + " " }}<em>{{ search }}</em>
								</template>
							</template>
							<template #option="{label}">
								{{ label }}
							</template>
						</v-select>
					</div>
				</vs-col>
				<vs-col vs-lg="1" vs-sm="12" vs-xs="12">
					<div class="flex items-center mt-6">
						<vs-button icon-pack="feather" icon="icon-search" @click="getEventList(1)"
							>{{ $t("VisitPoints.Search") }}
						</vs-button>
					</div>
				</vs-col>
			</vs-row>
		</div>
		<ag-grid-vue
			ref="agGridTable"
			class="ag-theme-material w-100 my-4 ag-grid-table"
			:class="[{'ag-customizer-container': !isWidthPortatil}]"
			colResizeDefault="shift"
			:gridOptions="gridOptions"
			:columnDefs="columnDefs"
			:defaultColDef="defaultColDef"
			:rowData="eventsData"
			:animateRows="true"
			:pagination="true"
			:paginationPageSize="paginationPageSize"
			:suppressPaginationPanel="true"
			:enableRtl="$vs.rtl"
			:overlayNoRowsTemplate="overlayNoRowsTemplate"
			:overlayLoadingTemplate="overlayLoadingTemplate"
			:enableCellTextSelection="true"
			@rowSelected="rowSelected"
		>
		</ag-grid-vue>
		<vs-pagination :total="totalPages" :max="7" v-model="currentPage" />
	</div>
</template>

<script>
import {ScheduleWaypointsListMixin} from "@/components/optimization/export-waypoint/model/ScheduleWaypointsListMixin.js";

export default {
	mixins: [ScheduleWaypointsListMixin],
};
</script>

<style lang="scss" scoped>
#page-user-list {
	.user-list-filters {
		.vs__actions {
			position: absolute;
			right: 0;
			top: 50%;
			transform: translateY(-58%);
		}
	}
}
.add-new-data-sidebar {
	::v-deep .vs-sidebar--background {
		z-index: 51010;
		background-color: rgba(0, 0, 0, 0.7);
	}

	::v-deep .vs-sidebar {
		z-index: 51010;
		width: 450px;
		max-width: 90vw;

		.img-upload {
			margin-top: 2rem;

			.con-img-upload {
				padding: 0;
			}

			.con-input-upload {
				width: 100%;
				margin: 0;
			}
		}
	}
}
.disabled-option {
	color: gray;
	pointer-events: none; /* Evita la interacción */
	text-decoration: line-through; /* Opcional: Indica visualmente que está deshabilitado */
}
</style>
